import { NavigationClient } from "@azure/msal-browser";

export class CustomNavigationClient extends NavigationClient {

  constructor(navigate) {
    super();
    this.navigate = navigate;
  }

  async navigateInternal(url, options) {
    const relativePath = url.replace(window.location.origin, "");
    if (options.noHistory) {
      await this.navigate({ to: relativePath, replace: true });
    } else {
      await this.navigate({ to: relativePath });
    }
    return false;
  }
}
